import { forwardRef } from 'react';
import { StyledList } from './styled';

const List = forwardRef((props, ref) => <StyledList ref={ref} {...props} />);

export default List;
